import { getLocaleTag } from '../intl'
import type { Price } from '../question/models/Question'

export const formatPrice = ({ value, currency }: Pick<Price, 'value' | 'currency'>): string =>
  new Intl.NumberFormat(getLocaleTag(), { style: 'currency', currency }).format(value)
